// Autogenerated file
export const gasStationTypesEnum = {
    Tatneft: "Tatneft",
    Gazpromneft: "Gazpromneft",
    Rosneft: "Rosneft",
};
export const gasStationTypes = [
    { label: "Татнефть", value: "Tatneft", intValue: 1 },
    { label: "Газпромнефть", value: "Gazpromneft", intValue: 2 },
    { label: "Роснефть", value: "Rosneft", intValue: 4 },
];
